export default __webpack_public_path__ + "6ee4e183a0f1f06ce17accefe270e8e0.png";